import { useEffect, useState } from "react";
import { CampaignsResponse, routes } from "@/services/campaigns.service";
import useSWR from "swr";
import { fetcherV2 } from "@/services/api";

interface Props {
  initialPage: number;
  limit: number;
  sortBy: string;
  sortDirection: "ASC" | "DESC";
  select?: string[];
}

export function useCampaigns({
  initialPage,
  limit,
  sortBy,
  sortDirection,
  select,
}: Props) {
  const [page, setPage] = useState<number>(initialPage);
  const [pages, setPages] = useState<number>(0);

  const { data, error, mutate, isLoading } = useSWR(
    () => [routes.list, { page, limit, sortBy, sortDirection, select }],
    fetcherV2<CampaignsResponse>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  useEffect(() => {
    if (data && !isLoading) {
      setPages(data.pages);
    }
  }, [data, isLoading]);

  return {
    campaigns: data?.result ?? [],
    refresh: mutate,
    total: data?.total ?? 0,
    page: page + 1,
    pages: pages,
    next: () => setPage((p) => p + 1),
    previous: () => setPage((p) => p - 1),
    canPrevious: page > 0,
    canNext: page + 1 < pages,
    isLoading: !error && !data,
    isError: error,
    pageSize: limit,
  };
}
